import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class DataService {

  private messageSource = new BehaviorSubject("");
  currentMessage = this.messageSource.asObservable();

  private searchText = new BehaviorSubject("");
  private assetLists = new BehaviorSubject<any>({
  });
  private creativeLists = new BehaviorSubject<any>({
  });
  private vendorLists = new BehaviorSubject<any>({
  });
  private userInfo = new BehaviorSubject("");
  constructor() { }

  changeMessage(message: string) {
    this.messageSource.next(message)
  }

  setSearchText(input: string) {
    this.searchText.next(input);
  }


  callUserInfo() {
    this.userInfo.next('');
  }
  getUserInfo() {
    return this.userInfo.asObservable();
  }

  getSearchText() {
    return this.searchText.asObservable();
  }
  setAssetDataLists(assets: any) {
    this.assetLists.next(assets);
  }

  getAssetDataLists() {
    return this.assetLists.asObservable();
  }


  setCreativeDataLists(creative: any) {
    this.creativeLists.next(creative);
  }

  getCreativeDataLists() {
    return this.creativeLists.asObservable();
  }

  setVendorDataLists(vendor: any) {
    this.vendorLists.next(vendor);
  }

  getVendorDataLists() {
    return this.vendorLists.asObservable();
  }
}